import { axiosInstance } from "../core/http";

export const internApi = {
  getMatchTask: (taskType) =>
    axiosInstance.get(`/panel/study/pipe-conflict/${taskType}/`),
  postMatchTask: (taskId, answer, taskType = "") =>
    axiosInstance.post(`/panel/study/answer/`, {
      pipe_conflict: taskId,
      answer: answer,
      task_type: taskType,
    }),
  getMatchTaskReport: () => axiosInstance.get(`/panel/study/report/`),
};
